import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Material Modules
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';

// Modules
import { ElementsModule } from '@modules/elements/elements.module';
import { PreviewModule } from '@modules/preview/preview.module';
import { TasksModule } from '@modules/tasks/tasks.module';

// Components
import { RecordListComponent } from './components/record-list/record-list.component';
import { CreateRecordComponent } from './components/create-record/create-record.component';
import { RecordInfoComponent } from './components/record-info/record-info.component';
import { RecordLogsComponent } from './components/record-logs/record-logs.component';
import { RecordManualUploadComponent } from './components/record-logs/record-manual-upload/record-manual-upload.component';
import { RecordTestFilenameComponent } from './components/record-logs/record-test-filename/record-test-filename.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    // Materials
    MatDialogModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatSliderModule,
    MatTooltipModule,
    ClipboardModule,

    ElementsModule,
    PreviewModule,
    TasksModule,
  ],
  declarations: [
    RecordListComponent,
    CreateRecordComponent,
    RecordInfoComponent,
    RecordLogsComponent,
    RecordManualUploadComponent,
    RecordTestFilenameComponent,
  ],
  exports: [
    RecordListComponent,
    CreateRecordComponent,
    RecordInfoComponent,
    RecordLogsComponent,
  ],
})
export class RecordsModule { }
